import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { GridModule, ColumnChooserService, PageService, SortService, FilterService, ResizeService } from '@syncfusion/ej2-angular-grids';
import { DischargeCodesComponent } from './discharge-codes.component';
import { NumericTextBoxModule, NumericTextBoxAllModule } from '@syncfusion/ej2-angular-inputs';
import { NgxUiLoaderModule } from 'ngx-ui-loader';
import { MaskedTextBoxModule } from '@syncfusion/ej2-angular-inputs';
import { DischargeCodesRoutingModule } from './discharge-codes-routing.module';
@NgModule({
  declarations: [
    DischargeCodesComponent
  ],
  exports:[DischargeCodesComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    GridModule,
    NumericTextBoxModule,
    NumericTextBoxAllModule,
    NgxUiLoaderModule,
    MaskedTextBoxModule,
    DischargeCodesRoutingModule

  ],
  providers: [,ColumnChooserService,PageService,SortService,FilterService, ResizeService],
})
export class DischargeCodesModule { }
